import React, { useEffect, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { fetchWorkEntriesProjectTracking } from "../../../../store/slices/workentriesSlice";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import ProgressTracker from "../../../../utils/ProgressTracker";
import SelectResourceDropdown from "./SelectResourceDropdown";
import SelfTaskTrackManager from "./SelfTaskTrack/SelfTaskTrackManager";
import { fetchEmployees } from "./../../../../store/actions/employeeActions";
import { fetchDescriptionTasksProjectTracking } from "../../../../store/slices/DescriptionTask";
import { fetchHardwareProjectTracking } from "../../../../store/slices/hardwareDescriptionSlice";
import { useSnackbar } from "notistack";
import { completeProject } from "../../../../store/slices/ProjectOngoing/projectOngoingSlice";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadSales from "../../SalesOperations/SaleOperation/ResponseReceived/FileUploadSales";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { setProjectReadTrue } from "../../../../store/slices/readSlice";
import DateConversion from "../../../../utils/DateConversion";
import { setSelectedProjectName } from "../../../../store/slices/ProjectOngoing/taskScrollSlice";
import { useLoggedUser } from "../../../../utils/useLoggedUser";
import OpTaskTrackManager from "./OpTaskTrack/OpTaskTrackManager";
import HardwareTrack from "./OpTaskTrack/OpHardware/HardwareTrack";
import { setHardwareRowOngoing } from "../../../../store/slices/ProjectOngoing/operationFeatureSlice";
import store from "../../../../store/store";
import { fetchGroups } from "../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../store/slices/MyTraining/myTrainings";
import {
  areAllAssignedTrainingsCompletedForOngoingProject,
  taskTypeServiceMatchesAssignmentRow,
} from "../../../../utils/trainingOtherExpenseSync";

const ProjectOngoingManager = ({ ongoingProjectsManager, handlerefresh, isViewOnly = false }) => {
  const loggedUser = useLoggedUser();
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const { formatDateByCountry } = DateConversion();

  const { employees } = useSelector((state) => state.employees);
  const { projects } = useSelector((state) => state.projects);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { group: groups } = useSelector((state) => state.group);

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );
  const hardwareRowOngoing = useSelector(
    (state) => state.operationFeature.hardwareRowOngoing
  );
  const selectedProjectName = useSelector(
    (state) => state.taskScroll.selectedProjectName
  );
  const selectedTaskId = useSelector(
    (state) => state.taskScroll.selectedTaskId
  );

  useEffect(() => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchEmployees());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = React.useCallback(
    (projectRow) => {
      const groupId = projectRow?.groupid?._id || projectRow?.groupid;
      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }
      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  // Update hardwareRowOngoing when projects are updated (e.g., after submission)
  useEffect(() => {
    if (hardwareRowOngoing?._id && projects?.length > 0) {
      const updatedProject = projects.find((p) => p._id === hardwareRowOngoing._id);
      if (updatedProject && JSON.stringify(updatedProject) !== JSON.stringify(hardwareRowOngoing)) {
        dispatch(setHardwareRowOngoing(updatedProject));
      }
    }
  }, [projects, hardwareRowOngoing, dispatch]);

  const handlerefreshs = () => {
    handlerefresh();
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchEmployees());
  };

  const [customProjectData, setCustomProjectData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  console.log("customProjectData projectData", projectData);

  useEffect(() => {
    if (
      !ongoingProjectsManager?.length
    ) {
      setProjectData([]);
      return;
    }
    const mergedData = ongoingProjectsManager.map((project) => {
      const isHardware =
        project?.TypeService?.toLowerCase().includes("hardware");

      const totalWorkEntries = isHardware
        ? hardwareProjectTracking.filter(
          (entry) => entry.projectid === project._id
        )
        : projectTrackingWorkEntries.filter(
          (entry) => entry.projectid === project._id
        );

      const totalDescriptions = descriptionProjectTracking.filter(
        (entry) => entry.projectid === project._id
      );
      const allEntries = [...totalWorkEntries, ...totalDescriptions]
      return {
        projectid: project._id,
        project: project,
        allEntries: allEntries,
      };
    });
    setProjectData(mergedData);
  }, [
    ongoingProjectsManager,
    projectTrackingWorkEntries,
    descriptionProjectTracking,
    hardwareProjectTracking,
  ]);

  useEffect(() => {
    if (
      !ongoingProjectsManager?.length
    ) {
      setCustomProjectData([]);
      return;
    }

    const mergedData = ongoingProjectsManager.map((project) => {
      const isHardware =
        project?.TypeService?.toLowerCase().includes("hardware");

      const totalWorkEntries = isHardware
        ? hardwareProjectTracking.filter(
          (entry) => entry.projectid === project._id
        )
        : projectTrackingWorkEntries.filter(
          (entry) => entry.projectid === project._id
        );

      const totalDescriptions = descriptionProjectTracking.filter(
        (entry) => entry.projectid === project._id
      );

      let calculatedAggregateMap = 0;

      if (isHardware) {
        // ✅ existing logic (unchanged)
        // const allProjectEntries = [...totalWorkEntries, ...totalDescriptions];

        // const totalTasks = allProjectEntries.length;
        // const completedTasks = allProjectEntries.filter(
        //   (entry) => entry.isTaskComplete
        // ).length;

        // calculatedAggregateMap =
        //   totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;
        const completedWorkEntries = totalWorkEntries.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const completedDescriptions = totalDescriptions.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const workProgress =
          totalWorkEntries.length > 0
            ? (completedWorkEntries / totalWorkEntries.length) * 90
            : 0;

        const descriptionProgress =
          totalDescriptions.length > 0
            ? (completedDescriptions / totalDescriptions.length) * 10
            : 0;

        calculatedAggregateMap = workProgress + descriptionProgress;
      } else {
        // ✅ proportion-based logic (90% + 10%)
        const completedWorkEntries = totalWorkEntries.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const completedDescriptions = totalDescriptions.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const workProgress =
          totalWorkEntries.length > 0
            ? (completedWorkEntries / totalWorkEntries.length) * 90
            : 0;

        const descriptionProgress =
          totalDescriptions.length > 0
            ? (completedDescriptions / totalDescriptions.length) * 10
            : 0;

        calculatedAggregateMap = workProgress + descriptionProgress;
      }

      return {
        projectid: project._id,
        totalWorkEntries,
        calculatedAggregateMap,
      };
    });
    setCustomProjectData(mergedData);
  }, [
    ongoingProjectsManager,
    projectTrackingWorkEntries,
    descriptionProjectTracking,
    hardwareProjectTracking,
  ]);

  const [currentProject, setCurrentProject] = useState(null);
  const [showAttach, setShowAttach] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [openInputReceived, setOpenInputReceived] = useState(null);

  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const [sortedProjects, setSortedProjects] = useState([]);

  useEffect(() => {
    setSortedProjects(ongoingProjectsManager);
  }, [ongoingProjectsManager]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query);
  };

  const totalItems = sortedProjects.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects.slice(startIdx, endIdx);
  console.log("matchedEmployees paginatedProjects", paginatedProjects)

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = ongoingProjectsManager.filter((LeadReport) =>
      getDisplayGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) => compareStrings(getDisplayGroupName(a), getDisplayGroupName(b)));
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) => compareStrings(getDisplayGroupName(b), getDisplayGroupName(a)));
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [aggregateProgressMap, setAggregateProgressMap] = useState({});
  // const [openProjectId, setOpenProjectId] = useState(null);

  // const handleCompleteProject = useCallback(
  //   async (row) => {
  //     const projectid = row?._id;

  //     if (!projectid) {
  //       enqueueSnackbar("Something Went Wrong", {
  //         variant: "error",
  //       });
  //       return;
  //     }

  //     setIsLoading(true);
  //     try {
  //       await dispatch(completeProject(projectid));
  //       dispatch(fetchAllProjects());
  //       enqueueSnackbar("Project Completed Successfully", {
  //         variant: "success",
  //       });
  //     } catch {
  //       enqueueSnackbar("Failed To Complete Project", { variant: "error" });
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   },
  //   [dispatch, enqueueSnackbar, setIsLoading]
  // );

  // useEffect(() => {
  //   if (projectData?.length > 0) {
  //     const matchedProject = projectData.find((proj) => proj?.allEntries?.every((entry) => entry?.isTaskComplete))
  //     if (!matchedProject) return;

  //     const assignedPersons =
  //       matchedProject?.project?.Assignedperson ?? [];

  //     const allPersonsCompleted = assignedPersons.every(
  //       (person) => person?.isProjectComplete === true
  //     );
  //     if (!allPersonsCompleted) {
  //       handleCompleteProject(matchedProject?.project);
  //     }
  //   }
  // }, [projectData, handleCompleteProject])

  const handleCompleteProject = async (row) => {
    if (isViewOnly) return;
    const projectid = row?._id;
    if (!projectid) {
      enqueueSnackbar("Something Went Wrong", {
        variant: "error",
      });
      return;
    }
    setIsLoading(true);
    try {
      await dispatch(completeProject(projectid));
      // Refetch all data to ensure immediate UI update
      await Promise.all([
        dispatch(fetchAllProjects()),
        dispatch(fetchHardwareProjectTracking()),
        dispatch(fetchDescriptionTasksProjectTracking()),
        dispatch(fetchWorkEntriesProjectTracking()),
      ]);
      
      // Call handlerefresh to trigger parent component re-render with updated data
      if (handlerefresh) {
        handlerefresh();
      }
      
      // Update hardwareRowOngoing in Redux if it's the current row being viewed
      // This ensures the hardware components get the updated row with isProjectComplete === true
      if (hardwareRowOngoing?._id === projectid) {
        // Get updated projects from Redux store
        const state = store.getState();
        const updatedProjects = state?.projects?.projects || [];
        const updatedProject = updatedProjects.find((p) => p._id === projectid);
        if (updatedProject) {
          dispatch(setHardwareRowOngoing(updatedProject));
        }
      }
      enqueueSnackbar("Project Completed Successfully", {
        variant: "success",
      });
    } catch {
      enqueueSnackbar("Failed To Complete Project", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleleadread = async (row) => {
    if (isViewOnly) return;
    if (row.isRead === false) {
      const projectId = row._id;
      try {
        await dispatch(setProjectReadTrue(projectId));
      } catch (error) {
        console.error("Error updating Notes:", error);
      } finally {
        handlerefresh();
      }
    }
  };

  const [selectedResource, setSelectedResource] = useState({});
  const [showHideToggle, setShowHideToggle] = useState(null);
  const [rowId, setRowId] = useState(null);
  const [showListState, setShowListState] = useState("tasktable");
  const [clickedProject, setClickedProject] = useState(null);
  const [submitProject, setSubmitProject] = useState(false);
  console.log("matchedEmployees1 rowId", rowId)
  console.log("matchedEmployees1 selectedProjectName", selectedProjectName)

  const ProjectOngoingref = useRef(null);
  useEffect(() => {
    if (rowId) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectOngoingref.current.scrollWidth;
      ProjectOngoingref.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [rowId]);

  useEffect(() => {
    if (!selectedProjectName || !sortedProjects) return;
    // Find index in the FULL list (not the paginated one)
    const globalIndex = sortedProjects.findIndex(
      (p) => p.ProjectName?.toLowerCase() === selectedProjectName?.toLowerCase()
    );
    if (globalIndex === -1) return;
    // Calculate page number where that project exists
    const pageNumber = Math.floor(globalIndex / itemsPerPage) + 1;
    // Change the page first
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
    }
  }, [selectedProjectName, currentPage, sortedProjects]);

  const refs = useRef({}); // store refs by task id
  useEffect(() => {
    if (
      selectedProjectName &&
      paginatedProjects.length > 0 &&
      refs.current[selectedProjectName]
    ) {
      setTimeout(() => {
        if (refs.current[selectedProjectName]) {
          refs.current[selectedProjectName].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        dispatch(setSelectedProjectName(null));
      }, 50); // 0–50ms works best
    }
  }, [selectedProjectName, paginatedProjects, dispatch]);

  useEffect(() => {
    if (selectedProjectName) {
      const ProjectToScroll = paginatedProjects?.find(
        (proj) => proj?.ProjectName === selectedProjectName
      );
      setRowId(ProjectToScroll?._id);
      setShowListState("tasktable");
    }
    if (selectedProjectName) {
      const index = paginatedProjects.findIndex(
        (p) =>
          p.ProjectName?.toLowerCase() === selectedProjectName?.toLowerCase()
      );
      if (index !== -1) {
        setShowHideToggle(index);
      } else {
        setShowHideToggle(null); // not found
      }
    }
  }, [selectedProjectName, paginatedProjects]);

  // Track which projects have already shown completion notifications
  const notifiedProjectsRef = useRef(new Set());

  // Check for project completion and show notifications to the last manager who submitted
  useEffect(() => {
    if (!ongoingProjectsManager?.length || !projects?.length || !loggedUser?.EmpEmail) return;

    ongoingProjectsManager.forEach((row) => {
      // Get all projects matching this row (by quotationId or ProjectName)
      const matchedProjects = projects.filter((proj) =>
        (row.quotationId != null && proj.quotationId != null)
          ? String(proj.quotationId) === String(row.quotationId)
          : proj.ProjectName === row.ProjectName
      );

      // Check if all projects have all assigned persons completed
      const allProjectsCompleted = matchedProjects.every((project) => {
        if (!project?.Assignedperson || project.Assignedperson.length === 0) {
          return false; // No assigned persons means not completed
        }
        // Check if ALL assigned persons have isProjectComplete === true
        return project.Assignedperson.every((person) => person?.isProjectComplete === true);
      });

      if (allProjectsCompleted) {
        // Find all managers in the project
        const managers = matchedProjects
          .flatMap((proj) => proj.Assignedperson || [])
          .filter((person) => {
            const emp = employees.find((e) => e.EmpEmail === person.email);
            return emp?.customRoles?.some((role) => 
              role?.toLowerCase().includes("project manager")
            );
          });

        // Check if current logged-in user is a manager in this project
        const currentManager = managers.find(
          (person) => person.email === loggedUser.EmpEmail
        );

        if (currentManager) {
          // Check if this manager has submitted (projecttracktaskStatus === "submit" and taskStatus === "submit")
          const hasSubmitted = 
            currentManager.projecttracktaskStatus === "submit" &&
            currentManager.taskStatus === "submit";

          // Check if all other managers have also submitted
          const allOtherManagersSubmitted = managers
            .filter((m) => m.email !== loggedUser.EmpEmail)
            .every(
              (m) =>
                m.projecttracktaskStatus === "submit" &&
                m.taskStatus === "submit"
            );

          // Show notification if:
          // 1. Current manager has submitted
          // 2. All other managers have also submitted (making current manager potentially the last one)
          // OR if there's only one manager (current one)
          if (
            hasSubmitted &&
            (allOtherManagersSubmitted || managers.length === 1)
          ) {
            // Create a unique key for this project group
            const projectKey = row.quotationId
              ? `completed_manager_${row.quotationId}_${loggedUser.EmpEmail}`
              : `completed_manager_${row.ProjectName}_${loggedUser.EmpEmail}`;

            // Only show notification if we haven't shown it before
            if (!notifiedProjectsRef.current.has(projectKey)) {
              notifiedProjectsRef.current.add(projectKey);

              // Show notification in bottom right with blue background
              enqueueSnackbar(
                `Project "${row.ProjectName}" completion by the manager and waiting for your approval`,
                {
                  variant: "info",
                  anchorOrigin: { vertical: "bottom", horizontal: "right" },
                  autoHideDuration: 5000,
                }
              );
            }
          }
        }
      } else {
        // If project is no longer completed, remove from notified set (in case it was reverted)
        const projectKey = row.quotationId
          ? `completed_manager_${row.quotationId}_${loggedUser.EmpEmail}`
          : `completed_manager_${row.ProjectName}_${loggedUser.EmpEmail}`;
        notifiedProjectsRef.current.delete(projectKey);
      }
    });
  }, [ongoingProjectsManager, projects, employees, loggedUser, enqueueSnackbar]);

  return (
    <div>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <>
        <div className="flex justify-between items-center p-2 bg-white  ">
          <div className=" font-semibold">Project Ongoing</div>

          <div className="flex gap-2 py-1 px-1 align-middle items-center bg-[#e0e7ff] rounded-full">
            <MdSearch className=" w-5 h-5 text-gray-500" />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchInputChange}
              placeholder="Search"
              className="bg-[#e0e7ff] outline-none w-[80%]"
            />
          </div>
        </div>
        <div
          ref={ProjectOngoingref}
          className=" min-h-[38vh] overflow-x-auto bg-white  h-full max-h-[95vh] overflow-auto pb-5"
        >
          <div className={`${rowId ? "min-w-[1900px]" : "w-auto"} `}>
            <div className="head bg-white rounded-t sticky top-0 z-[1299]">
              <div className="flex w-full h-full text-xs  text-center  bg-[#E8E8E8] text-black">
                <div
                  className={`font-semibold flex ${rowId ? "w-[40%] " : "w-[70%]"
                    }`}
                >
                  <div className="h-12 w-[8%] pl-2 flex-shrink-0 border flex justify-start items-center ">
                    Sr. No
                  </div>
                  <div
                    className={`h-12 w-[20%]  border p-2 break-words text-wrap flex justify-around items-center align-middle`}
                  >
                    <p className="w-[75%] break-words whitespace-normal text-start">
                      Group
                    </p>
                    <div className="w-[25%] flex flex-col">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          sortAlphabetically("AssignedGroup", "az")
                        }
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() =>
                          sortAlphabetically("AssignedGroup", "za")
                        }
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`h-12 w-[20%]  border p-2 break-words text-wrap flex justify-around items-center align-middle`}
                  >
                    <p className="w-[75%] break-words whitespace-normal text-start">
                      Project
                    </p>
                    <div className="w-[25%] flex flex-col">
                      <div
                        className="cursor-pointer "
                        onClick={() => sortAlphabetically("ProjectName", "az")}
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() => sortAlphabetically("ProjectName", "za")}
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`h-12 w-[18%] relative border break-words whitespace-normal flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}
                  >
                    <p className=" break-words whitespace-normal pl-2 pr-2">
                      Date Requested
                    </p>
                    <div className="absolute right-0 flex flex-col">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          sortAlphabetically("DateRequested", "az")
                        }
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() =>
                          sortAlphabetically("DateRequested", "za")
                        }
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`h-12 w-[18%] relative border break-words whitespace-normal flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}
                  >
                    Due Date
                    <div className="absolute right-0 flex flex-col">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          sortAlphabetically("ProjectDueDate", "az")
                        }
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() =>
                          sortAlphabetically("ProjectDueDate", "za")
                        }
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`h-12 w-[16%] border break-words whitespace-normal flex-shrink-0 p-2 truncate flex justify-around items-center align-middle text-xs line-clamp-2`}
                  >
                    Attachment
                  </div>
                </div>
                {rowId ? (
                  <div className="w-[60%] ">
                    <div className="h-12 w-full flex font-semibold bg-[#E8E8E8] text-black">
                      <div className="w-[15%] bg- border p-2 break-words text-wrap flex justify-around items-center align-middle">
                        Resources
                      </div>
                      <div className="w-[68%]  border break-words text-wrap flex flex-col justify-around items-center align-middle">
                        <div className="w-full h-[50%] border break-words text-wrap flex justify-center items-center">
                          Task Details
                        </div>
                        <div className="w-full h-[50%] border break-words text-wrap flex ">
                          <div
                            onClick={() => setShowListState("tasktable")}
                            className={`w-[50%] border-r-2 ${showListState === "tasktable"
                              ? "bg-blue-500 text-white"
                              : "text-black"
                              }  cursor-pointer flex justify-center items-center`}
                          >
                            {clickedProject?.TypeService?.toLowerCase().includes(
                              "hardware"
                            )
                              ? "Part List"
                              : "Effort Expenses"}
                            {/* {clickedProject.TypeService === "Hardware" ? "Part List" : "Effort Expenses"} */}
                          </div>
                          <div
                            onClick={() => setShowListState("otherexpenses")}
                            className={` w-[50%] ${showListState === "otherexpenses"
                              ? "bg-blue-500 text-white"
                              : "text-black"
                              } cursor-pointer flex justify-center items-center`}
                          >
                            Other Expenses
                          </div>
                        </div>
                      </div>

                      <div className="w-[17%] border p-2 break-words text-wrap flex justify-around items-center align-middle">
                        Progress Tracker
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="w-[30%] bg-[#E8E8E8] text-black">
                      <div className="w-full font-semibold flex h-full">
                        <div className="w-[50%] border p-2 break-words text-wrap flex justify-around items-center align-middle">
                          Task Details
                        </div>
                        <div className="w-[50%] border p-2 break-words text-wrap flex justify-around items-center align-middle">
                          Progress Tracker
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="w-[100%]">
              {paginatedProjects.map((row, index) => {
                const matchedProjectWorkEntries =
                  projectTrackingWorkEntries?.filter(
                    (entry) => entry?.projectid === row?._id
                  ) || [];
                const matchedOpWorkEntries =
                  matchedProjectWorkEntries?.filter(
                    (entry) =>
                      entry?.taskownerid === selectedResource?.employee?._id
                  ) || [];

                const matchedManagerWorkEntries =
                  matchedProjectWorkEntries?.filter(
                    (entry) =>
                      entry?.projectid === row?._id &&
                      (entry?.taskownerid === selectedResource?.employee?._id ||
                        entry?.taskownerid === loggedUser?._id)
                  ) || [];

                const matchedHardwarePartsManager =
                  hardwareProjectTracking?.filter(
                    (entry) =>
                      entry?.projectid === row?._id &&
                      entry?.taskownerid === loggedUser?._id
                  ) || [];

                // Consolidated: manager's description entries + any other person's entries with same description (for one-row display and complete-all on checkbox)
                const managerDescEntries =
                  descriptionProjectTracking?.filter(
                    (entry) =>
                      entry?.projectid === row?._id &&
                      entry?.taskownerid === loggedUser?._id
                  ) || [];
                const managerDescSet = new Set(
                  managerDescEntries
                    .map((e) => (e?.description || "").trim())
                    .filter(Boolean)
                );
                const matchedHardwareDescriptionsPartsManager =
                  descriptionProjectTracking?.filter(
                    (entry) =>
                      entry?.projectid === row?._id &&
                      (entry?.taskownerid === loggedUser?._id ||
                        managerDescSet.has((entry?.description || "").trim()))
                  ) || [];

                const matchedDescriptionsProjects =
                  descriptionProjectTracking?.filter(
                    (entry) => entry?.projectid === row?._id
                  ) || [];

                const opOwnerIds = new Set(
                  [
                    selectedResource?.employee?._id,
                    selectedResource?.person?.personid,
                    selectedResource?.person?._id,
                  ]
                    .filter(Boolean)
                    .map((id) => String(id).trim())
                );
                const matchedHardwareDescriptionsPartsOP =
                  descriptionProjectTracking?.filter((entry) => {
                    if (entry?.projectid !== row?._id) return false;
                    if (!opOwnerIds.has(String(entry?.taskownerid ?? "").trim())) {
                      return false;
                    }
                    return taskTypeServiceMatchesAssignmentRow(entry, row);
                  }) || [];

                const matchedHardwarePartsOP =
                  hardwareProjectTracking?.filter(
                    (entry) =>
                      entry?.projectid === row?._id &&
                      entry?.taskownerid === selectedResource?.employee?._id
                  ) || [];

                const matchedHardwarePartsAllProject =
                  hardwareProjectTracking?.filter(
                    (entry) => entry?.projectid === row?._id
                  ) || [];
                const matchedHardwarDescriptionsAllProject =
                  descriptionProjectTracking?.filter(
                    (entry) => entry?.projectid === row?._id
                  ) || [];

                const trainingsCompleteForSubmit =
                  areAllAssignedTrainingsCompletedForOngoingProject({
                    projectRow: row,
                    trainingsEnvelope: mytrainings,
                    employees,
                    projects,
                  });

                const installationTrackingComplete =
                  matchedProjectWorkEntries?.every(
                    (entry) => entry.isTaskComplete
                  ) &&
                  matchedDescriptionsProjects?.every(
                    (entry) => entry.isTaskComplete
                  );

                const canSubmitInstallationProject =
                  installationTrackingComplete && trainingsCompleteForSubmit;

                const allTasksComplete =
                  matchedHardwarePartsAllProject?.every(
                    (entry) => entry.isTaskComplete
                  ) &&
                  matchedHardwarDescriptionsAllProject?.every(
                    (entry) => entry.isTaskComplete
                  ) &&
                  trainingsCompleteForSubmit;

                return (
                  <div
                    ref={(el) => (refs.current[row.ProjectName] = el)}
                    className={`flex text-xs w-full ${row.isRead === false ? "font-bold" : " "
                      } hover:bg-gray-100 cursor-pointer`}
                    key={index}
                  >
                    <div className=" flex w-full">
                      <div className={`flex ${rowId ? "w-[40%]" : "w-[70%]"} `}>
                        <div
                          onClick={() => {
                            dispatch(setHardwareRowOngoing(row))
                            const isOpening =
                              showHideToggle !== index || rowId !== row?._id;
                            setShowHideToggle(
                              showHideToggle === index ? null : index
                            );
                            setRowId(rowId === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`w-[8%] border-b flex justify-start align-middle items-center text-center pl-3`}
                        >
                          {startIdx + index + 1}{" "}
                        </div>
                        <div
                          onClick={() => {
                            dispatch(setHardwareRowOngoing(row))
                            const isOpening =
                              showHideToggle !== index || rowId !== row?._id;

                            setShowHideToggle(
                              showHideToggle === index ? null : index
                            );
                            setRowId(rowId === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`w-[20%] flex border-b justify-start align-middle items-center  p-2 break-words text-wrap`}
                        >
                          {getDisplayGroupName(row)}
                        </div>
                        <div
                          onClick={() => {
                            dispatch(setHardwareRowOngoing(row))
                            const isOpening =
                              showHideToggle !== index || rowId !== row?._id;

                            setShowHideToggle(
                              showHideToggle === index ? null : index
                            );
                            setRowId(rowId === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`w-[20%] flex border-b justify-start align-middle items-center text-center p-2 break-words text-wrap overflow-hidden text-ellipsis line-clamp-2 whitespace-norma leading-snug text-xs`}
                        >
                          {row.ProjectName}
                        </div>
                        <div
                          onClick={() => {
                            dispatch(setHardwareRowOngoing(row))
                            const isOpening =
                              showHideToggle !== index || rowId !== row?._id;

                            setShowHideToggle(
                              showHideToggle === index ? null : index
                            );
                            setRowId(rowId === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`w-[18%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2`}
                        >
                          {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                            ? formatDateByCountry(row.DateRequested)
                            : ""}
                        </div>
                        <div
                          onClick={() => {
                            dispatch(setHardwareRowOngoing(row))
                            const isOpening =
                              showHideToggle !== index || rowId !== row?._id;

                            setShowHideToggle(
                              showHideToggle === index ? null : index
                            );
                            setRowId(rowId === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`w-[18%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2 `}
                        >
                          {row.ProjectDueDate &&
                            !isNaN(new Date(row.ProjectDueDate))
                            ? formatDateByCountry(row.ProjectDueDate)
                            : ""}
                        </div>
                        <div
                          className={`w-[16%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2`}
                        >
                          <AttachFileIcon
                            onClick={() => {
                              setCurrentProject(row);
                              setShowAttach(true);
                            }}
                            className="rotate-12 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div
                        className={`flex ${rowId ? "w-[60%]" : "w-[30%]"} flex`}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        {showHideToggle === index ? (
                          <>
                            <div
                              className={`w-full flex`}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <div className="w-[15%] p-1 flex border-b justify-center break-words text-wrap">
                                <SelectResourceDropdown
                                  setSelectedResource={setSelectedResource}
                                  selectedResource={selectedResource}
                                  index={index}
                                  row={row}
                                  employees={employees}
                                  setShowListState={setShowListState}
                                  selectedTaskId={selectedTaskId}
                                  isViewOnly={isViewOnly}
                                />
                              </div>
                              <div className="w-[68%] text-center break-words text-wrap border-b pt-2 pb-2">
                                {row?.TypeService?.toLowerCase().includes("hardware") ? (
                                  <>
                                    <HardwareTrack
                                      selectedResource={selectedResource}
                                      setIsLoading={setIsLoading}
                                      index={index}
                                      showListState={showListState}
                                      isViewOnly={isViewOnly}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {selectedResource.label === "Self" ? (
                                      <SelfTaskTrackManager
                                        handlerefresh={handlerefreshs}
                                        employees={employees}
                                        setIsLoading={setIsLoading}
                                        matchedManagerWorkEntries={
                                          matchedManagerWorkEntries
                                        }
                                        setAggregateProgressMap={
                                          setAggregateProgressMap
                                        }
                                        aggregateProgressMap={aggregateProgressMap}
                                        row={row}
                                        index={index}
                                        matchedProjectWorkEntries={
                                          matchedProjectWorkEntries
                                        }
                                        matchedHardwarePartsManager={
                                          matchedHardwarePartsManager
                                        }
                                        showListState={showListState}
                                        matchedHardwareDescriptionsPartsManager={
                                          matchedHardwareDescriptionsPartsManager
                                        }
                                        isViewOnly={isViewOnly}
                                      />
                                    ) : (
                                      <OpTaskTrackManager
                                        row={row}
                                        index={index}
                                        matchedOpWorkEntries={matchedOpWorkEntries}
                                        selectedEmployee={selectedResource?.employee}
                                        matchedHardwarePartsOP={
                                          matchedHardwarePartsOP
                                        }
                                        matchedHardwareDescriptionsPartsOP={
                                          matchedHardwareDescriptionsPartsOP
                                        }
                                        showListState={showListState}
                                        setIsLoading={setIsLoading}
                                        isViewOnly={isViewOnly}
                                      />
                                    )}
                                  </>
                                )}
                                {row?.TypeService?.toLowerCase().includes(
                                  "hardware"
                                ) ? (
                                  <>
                                    {/* {row?.Assignedperson.every(
                                      (entry) => entry?.isProjectComplete
                                    ) && (
                                        <div className="w-full flex justify-end p-2">
                                          <button className="cursor-default py-2 px-4 text-orange-600 border-b rounded-md text-start bg-gray-100">
                                            Project submitted & under review
                                          </button>
                                        </div>
                                      )
                                    } */}

                                    {row?.Assignedperson.every(
                                      (entry) => entry?.isProjectComplete
                                    ) ? (
                                      <div className="w-full flex justify-end p-2">
                                        <button className="cursor-default py-2 px-4 text-orange-600 border-b rounded-md text-start bg-gray-100">
                                          Project submitted & under review
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="flex justify-end items-center gap-2 p-2">
                                          <div className="relative inline-flex group">
                                            <button
                                              onClick={() =>
                                                setSubmitProject(true)
                                              }
                                              disabled={!allTasksComplete || isViewOnly}
                                              className={`py-1 px-4 rounded-md text-white ${allTasksComplete && !isViewOnly
                                                ? "bg-blue-500 hover:bg-blue-700"
                                                : "bg-gray-400 cursor-not-allowed"
                                                }`}
                                            >
                                              Submit Project
                                            </button>
                                            {!isViewOnly && !allTasksComplete && (
                                              <span className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-700 px-2 py-1 text-xs text-white opacity-0 pointer-events-none transition-opacity duration-150 group-hover:opacity-100">
                                                Complete all tasks and mark every assigned training as Completed in My Trainings
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                ) : (

                                  <>
                                    {/* {row.Assignedperson.every(
                                      (person) => person?.isProjectComplete
                                    ) && (
                                        <div className="w-full flex justify-end p-2">
                                          <button className="cursor-default py-2 px-4 text-orange-600 border rounded-md text-start bg-gray-100">
                                            Project submitted & under review
                                          </button>
                                        </div>
                                      )} */}

                                    {row.Assignedperson.every(
                                      (person) => person?.isProjectComplete
                                    ) ? (
                                      <div className="w-full flex justify-end p-2">
                                        <button className="cursor-default py-2 px-4 text-orange-600 border rounded-md text-start bg-gray-100">
                                          Project submitted & under review
                                        </button>
                                      </div>
                                    ) : (
                                      <div className="flex justify-end items-center gap-2 p-2">
                                        <div className="relative inline-flex group">
                                          <button
                                            disabled={
                                              isViewOnly ||
                                              !canSubmitInstallationProject
                                            }
                                            onClick={() =>
                                              setSubmitProject(true)
                                            }
                                            className={`py-1 px-4 rounded-md text-white ${!isViewOnly &&
                                              canSubmitInstallationProject
                                              ? "bg-blue-500 hover:bg-blue-700"
                                              : "bg-gray-400 cursor-not-allowed"
                                              }`}
                                          >
                                            Submit Project
                                          </button>
                                          {!isViewOnly &&
                                            !canSubmitInstallationProject && (
                                              <span className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-700 px-2 py-1 text-xs text-white opacity-0 pointer-events-none transition-opacity duration-150 group-hover:opacity-100">
                                                Complete all tasks and mark every assigned training as Completed in My Trainings
                                              </span>
                                            )}
                                        </div>
                                      </div>
                                    )}
                                  </>

                                )}

                                {submitProject && (
                                  <div className="fixed inset-0 z-[1300] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
                                    <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                                      <button
                                        onClick={() => setSubmitProject(false)}
                                        className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                                      >
                                        Close
                                      </button>
                                      <h2 className="text-[16px] text-start">
                                        Project Name :{" "}
                                        <span className="font-semibold">
                                          {row?.ProjectName}
                                        </span>
                                      </h2>

                                      <p className="mt-3 text-[14px] leading-6 text-start">
                                        Are you sure you want to submit this
                                        project ?
                                      </p>

                                      <div className="flex justify-start gap-4 mt-4">
                                        <button
                                          onClick={() => {
                                            if (isViewOnly) return;
                                            handleCompleteProject(row);
                                            setSubmitProject(false);
                                          }}
                                          disabled={isViewOnly}
                                          className={`py-2 px-7 text-white rounded-lg ${isViewOnly ? "bg-gray-400 cursor-not-allowed" : "bg-[#e32278]"}`}
                                        >
                                          Yes
                                        </button>
                                        <button
                                          onClick={() => {
                                            setSubmitProject(false);
                                          }}
                                          className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                                        >
                                          No
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="w-[17%] border-b pt-6 flex justify-center items-center">
                                <div className="w-[80%]">
                                  <ProgressTracker
                                    value={
                                      customProjectData.find(
                                        (p) => p.projectid === row._id
                                      )?.calculatedAggregateMap || 0
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {rowId ? (
                              <div
                                onClick={() => {
                                  dispatch(setHardwareRowOngoing(row))
                                  setShowHideToggle(
                                    showHideToggle === index ? null : index
                                  );
                                  setRowId(
                                    rowId === row?._id ? null : row?._id
                                  );
                                  setClickedProject(
                                    clickedProject === row ? null : row
                                  );
                                }}
                                className="w-full flex"
                              >
                                <div
                                  className={`flex ${rowId ? "w-[15%]" : ""
                                    } border-b justify-center items-center `}
                                ></div>
                                <div
                                  onClick={() => {
                                    dispatch(setHardwareRowOngoing(row))
                                    const isOpening =
                                      showHideToggle !== index ||
                                      rowId !== row?._id;

                                    setShowHideToggle(
                                      showHideToggle === index ? null : index
                                    );
                                    setRowId(
                                      rowId === row?._id ? null : row?._id
                                    );
                                    setClickedProject(
                                      clickedProject === row ? null : row
                                    );
                                    if (isOpening) {
                                      handleleadread(row);
                                    }
                                  }}
                                  className={`flex ${rowId ? "w-[68%]" : ""
                                    } border-b flex justify-center items-center `}
                                >
                                  {rowId ? "Task Details" : "Multiple"}
                                </div>
                                <div
                                  className={`flex ${rowId ? "w-[17%]" : ""
                                    } border justify-center items-center `}
                                >
                                  <div className="w-[80%]  pt-6  flex justify-end items-center">
                                    <ProgressTracker
                                      value={
                                        customProjectData.find(
                                          (p) => p.projectid === row._id
                                        )?.calculatedAggregateMap || 0
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                onClick={() => {
                                  dispatch(setHardwareRowOngoing(row))
                                  setShowHideToggle(
                                    showHideToggle === index ? null : index
                                  );
                                  setRowId(
                                    rowId === row?._id ? null : row?._id
                                  );
                                  setClickedProject(
                                    clickedProject === row ? null : row
                                  );
                                }}
                                className="w-full flex"
                              >
                                <div
                                  onClick={() => {
                                    dispatch(setHardwareRowOngoing(row))
                                    const isOpening =
                                      showHideToggle !== index ||
                                      rowId !== row?._id;

                                    setShowHideToggle(
                                      showHideToggle === index ? null : index
                                    );
                                    setRowId(
                                      rowId === row?._id ? null : row?._id
                                    );
                                    setClickedProject(
                                      clickedProject === row ? null : row
                                    );
                                    if (isOpening) {
                                      handleleadread(row);
                                    }
                                  }}
                                  className={`w-[50%] border-b flex justify-center items-center `}
                                >
                                  {rowId ? "Task Details" : "Multiple"}
                                </div>
                                <div
                                  className={`w-[50%] border-b flex justify-center items-center`}
                                >
                                  <div className="w-[80%] pt-6  flex justify-end items-center">
                                    <ProgressTracker
                                      value={
                                        customProjectData.find(
                                          (p) => p.projectid === row._id
                                        )?.calculatedAggregateMap || 0
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {paginatedProjects.length === 0 && (
                <div className="noDataAvailable p-2">No Result Found</div>
              )}
            </div>
          </div>
        </div>

        <div
          className={`pagination flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
            } `}
        >
          <div>
            {totalItems > 0 ? (
              <>
                Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                {totalItems} Entries
              </>
            ) : (
              <>
                {paginatedProjects.length > 0 && (
                  <>Showing {paginatedProjects.length} Entries</>
                )}
              </>
            )}
          </div>

          {totalPages > 1 && (
            <div className="flex">
              <button
                onClick={() => setCurrentPage(1)}
                className="px-2 py-2 mx-1 border rounded"
                disabled={currentPage === 1}
                title="First Page"
              >
                <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
              </button>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-2 py-2 mx-2 border rounded"
                disabled={currentPage === 1}
              >
                <ChevronRightIcon className="w-5 h-5 rotate-180" />
              </button>

              {Array.from({ length: 3 }, (_, index) => {
                const pageNumber = currentPage - 1 + index;
                if (pageNumber >= 1 && pageNumber <= totalPages) {
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => setCurrentPage(pageNumber)}
                      className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                        }`}
                    >
                      {pageNumber}
                    </button>
                  );
                }
                return null;
              })}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                className="px-2 py-2 mx-2 border rounded"
                disabled={currentPage === totalPages}
              >
                <ChevronRightIcon className="w-5 h-5" />
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                className="px-2 py-2 mx-1 border rounded"
                disabled={currentPage === totalPages}
                title="Last Page"
              >
                <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </>

      {showAttach && (
        <FileUploadSales
          currentProject={currentProject}
          setShowAttach={setShowAttach}
          employees={employees}
          isViewOnly={isViewOnly}
        />
      )}
    </div>
  );
};

export default ProjectOngoingManager;
